module.exports = __webpack_public_path__ + "img/3.2c25baf7.png";